module.exports = __webpack_public_path__ + "img/Senegal.1540f65a.svg";